(() => {
  'use strict';

  const initializeMobileNavigation = () => {
    const headerDrawer = document.querySelector('header-drawer[data-breakpoint="tablet"]');
    const details = headerDrawer?.querySelector('#Details-menu-drawer-container');
    const summary = details?.querySelector(':scope > summary');
    const drawer = details?.querySelector('#menu-drawer');
    const header = headerDrawer?.closest('.header');
    const search = header?.querySelector('.header__icon--search');
    const cart = header?.querySelector('#cart-icon-bubble');
    const scrollRegion = drawer?.querySelector('.mobilegs-menu-drawer__scroll');

    if (!details || !summary || !drawer || !search || !cart) return;

    const isVisible = (element) => {
      const rect = element.getBoundingClientRect();
      const style = window.getComputedStyle(element);

      return (
        !element.closest('[hidden]') &&
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.width > 0 &&
        rect.height > 0
      );
    };

    const drawerControls = () =>
      Array.from(
        drawer.querySelectorAll(
          'a[href], button:enabled, input:not([type="hidden"]):enabled, select:enabled, textarea:enabled, [tabindex]:not([tabindex="-1"])'
        )
      );

    const allControls = () => Array.from(new Set([summary, ...drawerControls(), search, cart]));

    const focusOrder = () => allControls().filter(isVisible);

    const focusControl = (element) => {
      allControls().forEach((control) => control.classList.remove('focused'));
      element?.classList.add('focused');
      element?.focus({ preventScroll: true });
      if (drawer.contains(element)) {
        element.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      }
    };

    const closeDrawer = (event) => {
      if (!details.open) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      summary.click();
      window.setTimeout(() => focusControl(summary), 450);
    };

    document.addEventListener(
      'keydown',
      (event) => {
        if (!details.open) return;

        if (event.key === 'Escape') {
          closeDrawer(event);
          return;
        }

        if (event.key !== 'Tab') return;

        const order = focusOrder();
        if (order.length === 0) return;

        const currentIndex = order.indexOf(document.activeElement);
        const nextIndex = event.shiftKey
          ? currentIndex <= 0
            ? order.length - 1
            : currentIndex - 1
          : currentIndex < 0 || currentIndex === order.length - 1
            ? 0
            : currentIndex + 1;

        event.preventDefault();
        event.stopImmediatePropagation();
        focusControl(order[nextIndex]);
      },
      true
    );

    scrollRegion?.addEventListener('focusin', (event) => {
      event.target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMobileNavigation, { once: true });
  } else {
    initializeMobileNavigation();
  }
})();
